import ImageModal from "./routines/ImageModal"
import MessagesList from "../../components/sendbird/MessagesList"
import CustomizedMessageInput from "../../components/sendbird/SBMessageInput"

const MessagesTab = () => {
  return (
    <>
      <MessagesList />
      <ImageModal />
      <CustomizedMessageInput />
    </>
  )
}

export default MessagesTab
